import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=6d12a142&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"
import style0 from "./PanelCard.vue?vue&type=style&index=0&id=6d12a142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12a142",
  null
  
)

export default component.exports